// extracted by mini-css-extract-plugin
export default {"dipPencilTipTransform":"rotate(-10deg)","root":"PencilIcon_root__NaCKf","outline":"PencilIcon_outline__ycDDk","background":"PencilIcon_background__-n63t"};